import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { lovable } from "@/integrations/lovable/index";
import { nextAwareRedirectUrl } from "@/lib/auth-redirect";

export const GoogleAuthButton = () => {
  const handleGoogleAuth = async () => {
    try {
      console.log("Starting Google authentication...");
      const result = await lovable.auth.signInWithOAuth("google", {
        redirect_uri: nextAwareRedirectUrl(),
      });

      if (result.error) {
        console.error("Google auth error:", result.error);
        throw result.error;
      }

      if (result.redirected) {
        return;
      }

      console.log("Google auth successful");
    } catch (error: any) {
      console.error("Google auth error details:", error);
      toast.error(error.message || "Failed to connect to Google");
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleGoogleAuth}
      className="w-full h-14 text-base font-semibold bg-white hover:bg-gray-50 border-2 border-gray-300 shadow-sm hover:shadow-md hover:border-gray-400 transition-all"
    >
      <img
        src="https://www.google.com/favicon.ico"
        alt="Google"
        className="w-6 h-6 mr-3"
      />
      Continue with Google
    </Button>
  );
};
